import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword, deleteUser } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/popup.css";

export default function Delete_Fleet_manager() {
  const navigate = useNavigate();
  const location = useLocation();
  //console.log(location);
  const fleet_manager_id = location.state.details.id;
  const delivery_agent_name = location.state.details.name;
  const delivery_agent_code = location.state.details.code;
  const delivery_agent_email = location.state.details.email;
  const [data, getData] = useState([]);
  const token = JSON.parse(sessionStorage.getItem("userToken"));

  const handleDeleteFleetManagerFromMongoDB = async () => {
    //console.log("fleet_manager_id");
    //console.log(fleet_manager_id, token);
    try {
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_delete/delete_fleet_manager",
        {
          method: "POST",

          body: JSON.stringify({
            token: token,
            fleet_manager_id: fleet_manager_id,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      const result = await response.json();
      //console.log(result.delivery_agent);
      getData(result.delivery_agent);
      //console.log('got here');
      //console.log(result);
      //console.log(data.vehicle_details, data.bank_details);

      // if (response.status === 200) {
      //   //console.log("data gotten succesfully");
      // } else {
      //   //console.log("some error occurred");
      // }
    } catch (error) {
      console.error("Error during the API request:", error);
      alert(
        "An error occurred while deleting the delivery agent. Please try again."
      );
    }
  };

  // Function to handle Firebase sign-in and account deletion
  const handleFirebaseAccountDeletion = async () => {
    const auth = getAuth();

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        delivery_agent_email,
        "pickload_delivery_agent"
      );
      const user = userCredential.user;

      if (user?.uid) {
        // Delete the user in Firebase
        await deleteUser(user);
        console.log("Firebase account deleted successfully.");
        handleDeleteFleetManagerFromMongoDB();
      } else {
        alert("An error occurred. Could not find user in Firebase.");
      }
    } catch (error) {
      console.error(
        "Error signing in or deleting Firebase account:",
        error.message
      );
      alert("Error deleting Firebase account: " + error.message);
    }
  };

  return (
    <div className="popup">
      <div className="popup-container">
        <div className="popup-background">
          <div className="popup-confirmation">
            <div className="popup-confirmation-info">
              Delete Fleet Manager Confirmation
            </div>
            <div className="popup-rematched">
              Are you sure you want to delete Fleet Manager<br></br>{" "}
              {delivery_agent_name} with fleet code<br></br>
              {delivery_agent_code}?
            </div>
          </div>
          <div className="popup-dialog-row">
            <div
              className="popup-dialog"
              onClick={() => navigate("/App/Fleet_Managers")}
            >
              No
            </div>
            <div className="middle-line">
              <hr className="popup-hr"></hr>
            </div>
            <div
              className="popup-dialog1"
              onClick={() => {
                handleFirebaseAccountDeletion();
                navigate("/App/Fleet_Managers");
              }}
            >
              Yes
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
